/* @generated */
import * as React from "react";
function getLargeViewBox(hasWhitespace, type) {
  if (hasWhitespace) {
    return "0 0 136 136";
  } else {
    return type === "other" ? "31 30 74 75.5" : "20 29 96 78";
  }
}
function getSmallViewBox(hasWhitespace, type) {
  if (hasWhitespace) {
    return "0 0 40 40";
  } else {
    return type === "other" ? "7 6 26 27.5" : "5 7 30 25";
  }
}
function useSmallContentIconViewBox({
  hasWhitespace,
  type = "other"
}) {
  const viewBox = React.useMemo(() => getSmallViewBox(hasWhitespace, type), [hasWhitespace, type]);
  return viewBox;
}
function useLargeContentIconViewBox({
  hasWhitespace,
  type = "other"
}) {
  const viewBox = React.useMemo(() => getLargeViewBox(hasWhitespace, type), [hasWhitespace, type]);
  return viewBox;
}
function getCompositeViewBox(hasWhitespace, size) {
  let viewBox = "";
  switch (size) {
    case "large":
      viewBox = hasWhitespace ? "-30 -30 136 136" : "0 0 76 76";
      break;
    case "small":
      viewBox = hasWhitespace ? "-7 -7 40 40" : "0 0 26 26";
      break;
  }
  return viewBox;
}
function useCompositeContentIconViewBox({
  hasWhitespace,
  size
}) {
  const viewBox = React.useMemo(
    () => getCompositeViewBox(hasWhitespace, size),
    [hasWhitespace, size]
  );
  return viewBox;
}
export {
  useCompositeContentIconViewBox,
  useLargeContentIconViewBox,
  useSmallContentIconViewBox
};
